import { Location } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { K_GOOGLE_CAPTCHA } from 'src/app/shared/constants';
import { A_PAYWALL_BG, A_PAYWALL_BG_OVERLAY } from 'src/app/shared/constants/assets.constants';
import { environment } from 'src/environments/environment';
import { DatalayerService } from './datalayer.service';
import { SeoService } from './seo.service';
import { StorageService } from './storage.service';
import { platformSettings, userSettings } from 'src/app/shared/constants/url.constants';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import * as SecureLS from 'secure-ls';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  settings;
  enableLive;
  siteLogo;
  siteIcon;
  homeBgImage;
  bannerHeading;
  bannerDescription;
  aboutSite;
  appstore;
  playstore;
  facebookLink;
  linkedinLink;
  twitterLink;
  pinterestLink;
  instagramLink;
  siteName;
  enablePolling;
  commentSection;
  seoUrl;
  enablePartnerVoucher;
  isSvodEnabled;
  isTvodEnabled;
  routeUrl;
  imagePath;
  convertedImagePath;
  stripeKey;
  displayLandingLocale;
  socialLink;
  socialAvail;
  webLogoUrl;
  commonBg;
  homeBg;
  showHeader = true;
  showFooter = true;
  logo: any;
  homeImage: any;
  facebookSignin;
  googleSignin;
  googleAnalytics;
  headerScripts;
  bodyScripts;
  pageH1Tag;
  pageTitleNew;
  pageDescription;
  pageKeyword;
  seo: any = {};
  virtualUrl;
  theoPlayerLibraryLocation: any;
  iosAppHref: any;
  androidAppHref: any;
  minimumWatchTime;
  enableCoupons: any;
  metroOnly;
  takeValue: number;
  userEmailNotified: any;
  googleRecaptcaKey: any;
  googleRecaptchaEnabled: any;
  paywallBgImage = A_PAYWALL_BG;
  paywallBgFallBackImage = A_PAYWALL_BG;
  paywallBgOverlay = A_PAYWALL_BG_OVERLAY;
  dEngageFlag: number;
  parentalControlModuleEnabled: number;
  geoBlockingFlag: any;
  player_language_options: any;
  s3_epg_path: any;
  epg_series_placeholder: any;
  epg_video_placeholder: any;
  epgChannelBgImage;
  display_epg_time_format: any;
  epgEnabled = 0;
  smartChannelsEnabled = 0;
  ezdrmWidevineLaurl;
  ezdrmPlayreadyLaurl;
  ezdrmFairplayCertificateUrl;
  ezdrmFairplayLaurl;
  enableTelco;
  youboraAccountCode;
  enableTrailers;
  enableCast;
  adsSupported;
  enableDrm;
  enableMatomoAnalytics;
  signInViaOperatorDisplay;
  displayOnTitle;
  churnPreventionFlowEnabled;
  displayQualityLevel;
  smartSignsEnabled;
  activateYourTvFromWebCode;
  activateYourTvFromTVCode;
  paywallEnabled;
  seoEnabled;
  gtmEnabled;
  isRelatedVod;
  genreCurationEnabled;
  loginWithMobileEnabled;
  youboraSiteName: any;
  showAuthPage = true;
  displayBannerTemplate;
  feedbackEnabled;
  whereToWatch;
  ezproxyEnabled;
  enableDeviceManagement;
  activeRouteInterval;
  concurrentStreamingnabled;
  webSocketUrl;
  enableRegistration;
  enableModerators;
  contentPartners;
  maxUserProfiles;
  imageClassMobile = {
    card: { "default": "sm", "400": "sm", "768": "md" },
    banner: { "default": "sm", "400": "sm", "768": "md" },
    background: { "default": "sm", "400": "sm", "768": "md" },
    logo: { "default": "sm", "400": "sm", "768": "md" },
    icon: { "default": "sm", "400": "sm", "768": "md" }
  };

  imageClassDesktop = {
    card: { "default": "sm", "1080": "md", "1440": "md", "2160": "md" },
    banner: { "default": "md", "1080": "lg", "1440": "lg", "2160": "xl" },
    background: { "default": "md", "1080": "lg", "1440": "lg", "2160": "xl" },
    logo: { "default": "md", "1080": "md", "1440": "lg", "2160": "lg" },
    icon: { "default": "sm", "1080": "sm", "1440": "md", "2160": "md" }
  };

  innerWidth;
  finalObject = {
    card:'',
    banner:'',
    background:'',
    icon:'',
    logo:''
  }

  constructor(private http: HttpClient, private location: Location, private route: ActivatedRoute,
    private storageService: StorageService, private datalayerService: DatalayerService,
    private seoService: SeoService, private router: Router) {
    this.innerWidth = window.innerWidth;
    this.getImageResolution()
  }

  getImageResolution() {
    this.innerWidth = window.innerWidth;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(window.navigator.userAgent);
    const imageClass = isMobile ? this.imageClassMobile : this.imageClassDesktop;
    let breakpoint = 'default';

    if (isMobile) {
      if (this.innerWidth >= 768) {
        breakpoint = '768';
      } else if (this.innerWidth >= 400) {
        breakpoint = '400';
      }
    } else {
      if (this.innerWidth >= 2160) {
        breakpoint = '2160';
      } else if (this.innerWidth >= 1440) {
        breakpoint = '1440';
      } else if (this.innerWidth >= 1080) {
        breakpoint = '1080';
      }
    }
    
    this.finalObject = {
      card: imageClass.card[breakpoint],
      banner: imageClass.banner[breakpoint],
      background: imageClass.background[breakpoint],
      icon: imageClass.icon[breakpoint],
      logo: imageClass.logo[breakpoint]
    };
  }

  settingFn(data: any) {
    this.settings = data;
    this.enableLive = +this.settings.linear_channel;
    this.siteIcon = this.settings.site_icon;
    this.homeBgImage = this.settings.home_page_bg_image;
    this.bannerHeading = this.settings.banner_heading;
    this.bannerDescription = this.settings.banner_description;
    this.aboutSite = this.settings.home_about_site;
    this.appstore = this.settings.appstore;
    this.playstore = this.settings.playstore;
    this.facebookLink = this.settings.facebook_link;
    this.linkedinLink = this.settings.linkedin_link;
    this.twitterLink = this.settings.twitter_link;
    this.pinterestLink = this.settings.pinterest_link;
    this.instagramLink = this.settings.instagram_link;
    this.siteName = this.settings.site_name;
    this.enablePolling = this.settings.enable_polling;
    this.commentSection = this.settings.comment_section;
    this.seoUrl = this.settings.seo_url;
    this.displayLandingLocale = +(this.settings.landing_locale_selection ?? 0);
    this.googleAnalytics = this.settings.web_google_analytics_script;
    this.headerScripts = this.settings.web_header_script;
    this.bodyScripts = this.settings.web_body_script;
    this.dEngageFlag = +this.settings.analytics_dengage;
    if (this.settings.analytics_youbora === '1' && this.settings.youbora_enabled_devices.split(',').includes('web')) {
      this.youboraAccountCode = this.settings.youbora_code ? this.settings.youbora_code : 'filmboxdev';
      this.youboraSiteName = this.settings?.youbora_site_name ? this.settings.youbora_site_name : environment.appName;
    }
    this.parentalControlModuleEnabled = +(this.settings.parental_control ?? 0);
    this.geoBlockingFlag = this.settings.geoblocking_for_content;
    if (this.settings.firebase_web_settings !== '') {
      // this.firebaseConfig = JSON.parse(this.settings.firebase_web_settings);
      // firebase.initializeApp(this.firebaseConfig);
    }
    this.routeUrl = this.settings.angular_site_url;
    this.imagePath = this.settings.image_base_path;
    this.convertedImagePath = this.imagePath.replace('/images/', '/converted/images/');
    this.webLogoUrl = this.imagePath + this.settings.web_logo;
    this.commonBg = this.imagePath + this.settings.common_bg_image;
    this.homeBg = this.imagePath + this.settings.home_page_bg_image;
    this.homeImage = this.imagePath + this.homeBgImage;
    this.logo = this.imagePath + this.settings.logo;
    this.siteLogo = this.imagePath + this.settings.web_logo;
    this.stripeKey = this.settings.stripe_key;
    this.storageService.setLocalStore('stripe_key', this.settings.stripe_key);
    if (this.stripeKey) {
      // angular.module('tv2zApp').config(function (StripeElementsProvider) {
      //   StripeElementsProvider.setAPIKey(this.stripeKey);
      // });
    }
    this.enablePartnerVoucher = this.settings.vouchers;
    this.isSvodEnabled = +(this.settings.svod ?? 0);
    this.isTvodEnabled = +(this.settings.tvod ?? 0);
    this.socialLink = {
      facebook: data.facebook_link,
      linkedin: data.linkedin_link,
      twitter: data.twitter_link,
      pinterest: data.pinterest_link,
      instagram: data.instagram_link,
      googlePlus: data.google_plus_link
    };
    this.socialAvail = this.socialLink.facebook || this.socialLink.linkedin || this.socialLink.twitter
      || this.socialLink.pinterest || this.socialLink.instagram || this.socialLink.googlePlus;
    this.facebookSignin = +(this.settings.app_facebook_signin ?? 0);
    this.googleSignin = +(this.settings.app_google_signin ?? 0);
    this.theoPlayerLibraryLocation = this.settings.theo_player_library_location;
    this.androidAppHref = this.settings.android_app_href;
    this.iosAppHref = this.settings.ios_app_href;
    this.minimumWatchTime = this.settings.minimum_duration_of_continue === '' ? 10 : +(this.settings.minimum_duration_of_continue);
    this.enableCoupons = this.settings.coupons;
    this.metroOnly = +(this.settings.metro_subs_via_web_payment ?? 0);
    this.takeValue = this.settings.take_value ? +(this.settings.take_value) : 12;
    this.ezdrmWidevineLaurl = this.settings.ezdrm_widevine_laurl;
    this.ezdrmPlayreadyLaurl = this.settings.ezdrm_playready_laurl;
    this.ezdrmFairplayCertificateUrl = this.settings.ezdrm_fairplay_certificate_url;
    this.ezdrmFairplayLaurl = this.settings.ezdrm_fairplay_laurl
    this.userEmailNotified = this.settings.user_email_notified;
    this.googleRecaptchaEnabled = this.settings.app_google_recaptcha;
    if (this.settings.app_google_recaptcha === "1") {
      this.googleRecaptcaKey = this.settings.google_recaptcha_key || K_GOOGLE_CAPTCHA;
    }
    this.epgEnabled = +(this.settings.linear_channel_epg ?? 0);
    if (this.epgEnabled) {
      this.s3_epg_path = this.settings.s3_epg_path;
      this.epg_series_placeholder = this.settings.epg_series_placeholder;
      this.epg_video_placeholder = this.settings.epg_video_placeholder;
      this.display_epg_time_format = this.settings.display_epg_time_format;
      this.epgChannelBgImage = this.settings.epg_channel_bg_image;
    }
    this.smartChannelsEnabled = +(this.settings.linear_channel_smart ?? 0);
    this.genreCurationEnabled = +(this.settings.genre_curation ?? 0);
    this.player_language_options = this.settings.player_language_options;
    this.enableDrm = +(this.settings.encoder_drm ?? 0);
    this.enableTelco = +(this.settings.telco ?? 0);
    this.enableTrailers = +(this.settings.trailer ?? 0);
    this.enableCast = +(this.settings.cast_and_crew ?? 0);
    this.adsSupported = +(this.settings.avod ?? 0);
    this.enableMatomoAnalytics = +(this.settings.analytics_media ?? 0);
    this.signInViaOperatorDisplay = +(this.settings.telco_signin ?? 0);
    this.displayOnTitle = +(this.settings.title_display_on_tile ?? 0);
    this.churnPreventionFlowEnabled = +(this.settings.app_svod_churn_flow ?? 0);
    this.displayQualityLevel = +(this.settings.player_quality_selection ?? 0);
    this.smartSignsEnabled = +(this.settings.smart_sign ?? 0);
    this.activateYourTvFromWebCode = +(this.settings.tv_web_activation ?? 0);
    this.activateYourTvFromTVCode = +(this.settings.tv_code_activation ?? 0);
    this.paywallEnabled = +(this.settings.paywall ?? 0);
    this.seoEnabled = +(this.settings.seo ?? 0);
    this.seoService.seoEnabled = this.seoEnabled;
    this.gtmEnabled = +(this.settings.analytics_gtm ?? 0);
    this.datalayerService.gtmEnabled = this.gtmEnabled;
    this.isRelatedVod = +(this.settings.is_related_vod ?? 0);
    this.loginWithMobileEnabled = +(this.settings.app_login_via_mobile_number ?? 0);
    this.displayBannerTemplate = this.settings.app_theme;
    this.showAuthPage = !this.facebookSignin && !this.googleSignin;
    this.feedbackEnabled = +(this.settings.app_user_feedback ?? 0);
    this.whereToWatch = this.settings.where_to_watch_url;
    this.ezproxyEnabled = +(this.settings.app_user_ezproxy_login ?? 0);
    this.enableDeviceManagement = +(this.settings.device_management ?? 0);
    this.activeRouteInterval = +(this.settings.active_route_interval);
    this.concurrentStreamingnabled = +(this.settings.concurrent_streaming ?? 0);
    this.webSocketUrl = this.settings.web_socket_url;
    // this.getSeo()
    this.enableRegistration = +(this.settings.app_user_registration ?? 0);
    this.enableModerators = +(this.settings.content_partner ?? 0);
    this.maxUserProfiles = +(this.settings.app_user_profiles ?? 0);
  }

  get settingsData() {
    return this.settings;
  }

  slugify(input) {
    // make lower case and trim
    let slug = input.toLowerCase().trim();
    // replace invalid chars with spaces
    // slug = slug.replace(/[^a-z0-9\s-]/g, ' ');
    // replace multiple spaces or hyphens with a single hyphen
    slug = slug.replace(/[\s-]+/g, '-');
    return slug;
  }

  getImage(image, type = null) {
    if (type) {
      let resolution = this.finalObject[type];
      const filename = image.split('.').slice(0, -1).join('.');
      return this.imagePath + filename + "_" + resolution +".webp";
    } else {
      const filename = image.split('.').slice(0, -1).join('.');
      return this.imagePath + filename + ".webp";
    }
  }

  setUTMFromSession() {
    const sessionParams = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'utm_term', 'utm_content'];
    const queryParams: any = {};

    sessionParams.forEach(param => {
      const sessionValue = this.storageService.getSessionStore(param);
      if (sessionValue) {
        queryParams[param] = sessionValue;
      }
    });

    if (Object.keys(queryParams).length > 0) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }

  handleDataMartAnalyticsParamsData() {
    let utm_campaign = this.storageService.getSessionStore('utm_campaign');
    let utm_medium = this.storageService.getSessionStore('utm_medium');
    let utm_source = this.storageService.getSessionStore('utm_source');
    let gclid = this.storageService.getSessionStore('gclid');
    let data = {};
    if (utm_source) {
      Object.assign(data, { 'source': utm_source });
    }
    if (utm_medium) {
      Object.assign(data, { 'medium': utm_medium });
    }
    if (utm_campaign) {
      Object.assign(data, { 'campaign': utm_campaign });
    }
    if (gclid) {
      Object.assign(data, { 'gclid': gclid });
    }
    let tvParams = JSON.parse(this.storageService.getSessionStore('tv_params'));
    if (tvParams) {
      Object.assign(data, tvParams);
    }
    return data;
  }

  getUTMurl(url = null) {
    url = url ?? (this.paywallEnabled ? environment.paywallURL : environment.routeUrl);
    const sessionParams = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'utm_term', 'utm_content'];
    const queryParams: any = {};

    sessionParams.forEach(param => {
      const sessionValue = this.storageService.getSessionStore(param);
      if (sessionValue) {
        queryParams[param] = sessionValue;
      }
    });

    const hasQueryParams = Object.keys(queryParams).length > 0;
    const queryString = new URLSearchParams(queryParams).toString();

    if (hasQueryParams) {
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}${queryString}`;
    }

    return url;
  }
  paramsHelper(paramsData) {
    let params: HttpParams = new HttpParams();
    Object.keys(paramsData).forEach((key) => {
      params = params.append(key, paramsData[key]);
    });
    return params;
  }
  getSeo() {
    // if (Object.keys(this.seo).length === 0) {
    //   const headers: Headers = new Headers({});
    //   headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //   headers.append('Content-Type', 'application/json');
    //   // this.http.get(this.seo_url).pipe(
    //   //   map((response) => {
    //   //     console.log("status: ", response)
    //   //     if (response['status'] = '200') {
    //   //       this.seo = response['data'];
    //   //       var pathname = location.pathname;
    //   //       var seourl = pathname.replace("/" + region + "/", '');
    //   //       if (this.seo.hasOwnProperty(seourl)) {
    //   //         this.pageH1Tag = this.seo[seourl]["h1"];
    //   //         this.pageTitleNew = this.seo[seourl]["title"];
    //   //         this.pageDescription = this.seo[seourl]["description"];
    //   //         this.pageKeyword = this.seo[seourl]["keywords"];
    //   //       } else {
    //   //         this.pageH1Tag = this.seo["default"]["h1"];
    //   //         this.pageTitleNew = this.seo["default"]["title"];
    //   //         this.pageDescription = this.seo["default"]["description"];
    //   //         this.pageKeyword = this.seo["default"]["keywords"];
    //   //       }
    //   //     }
    //   //     else
    //   //       console.log("Seo File not found");
    //   //   }, (error: HttpErrorResponse) => {
    //   //     console.log("Seo File not found");
    //   //   })
    //   // )
    // } else {
    //   const pathname = location.pathname;
    //   const seourl = pathname.replace('/' + region + '/', '');
    //   if (this.seo.hasOwnProperty(seourl)) {
    //     this.pageH1Tag = this.seo[seourl].h1;
    //     this.pageTitleNew = this.seo[seourl].title;
    //     this.pageDescription = this.seo[seourl].description;
    //     this.pageKeyword = this.seo[seourl].keywords;
    //   } else {
    //     this.pageH1Tag = this.seo.default.h1;
    //     this.pageTitleNew = this.seo.default.title;
    //     this.pageDescription = this.seo.default.description;
    //     this.pageKeyword = this.seo.default.keywords;
    //   }
    // }
    this.pageH1Tag = this.settings.h1_tag;
    this.pageTitleNew = this.settings.meta_title;
    this.pageDescription = this.settings.meta_description;
    this.pageKeyword = this.settings.meta_keywords;
    if (this.settings.meta_title) {
      this.seoService.setMetatitle(this.settings.meta_title);
    }
    if (this.settings.meta_keywords) {
      const metaData = { name: 'keywords', content: this.settings.meta_keywords };
      this.seoService.updateMetaTags(metaData);
    }
    if (this.settings.meta_description) {
      const metaData = { name: 'description', content: this.settings.meta_description };
      this.seoService.updateMetaTags(metaData);
    }
    if (this.settings.h1_tag) {
      this.seoService.pageH1Tag.next(this.settings.h1_tag);
    }
    this.seoService.metaTitle = this.settings.meta_title;
    this.seoService.keywords = this.settings.meta_keywords;
    this.seoService.description = this.settings.meta_description;
    let loginEvent = 'False';
    let userId = '';
    const autoUrl = this.route['_routerState']['snapshot'].url;
    const path = this.location.path();
    const absUrl = (autoUrl === '') ? this.routeUrl : autoUrl;
    this.virtualUrl = absUrl.substring(absUrl.indexOf(path));
    if (this.storageService.getLocalStore('u_id')) {
      loginEvent = 'True';
      userId = this.storageService.getLocalStore('u_id');
    }
    const datalayerData = {
      event: 'GAVirtual',
      pagePath: this.virtualUrl,
      pageTitle: (this.pageTitleNew ? this.pageTitleNew : 'Filmbox'),
      userId,
      loginStatus: loginEvent,
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
  }

  callPlatformSettings(params) {
    const url = environment.apiUrl + environment.v3_version + platformSettings;
    return this.http.get(url, { params }).pipe(
      map((response: any) => {
        return response;
      }, (error: HttpErrorResponse) => {
        return error
      })
    );
  }

  callUserSettings(url_params, params) {
    let url = environment.apiUrl + environment.v3_version + userSettings;
    url = url_params ? url + url_params : url;
    console.log(url, params);
    return this.http.post(url, {}, { params }).pipe(
      map((response: any) => {
        return response;
      }, (error: HttpErrorResponse) => {
        return error
      })
    );
  }

  getPlatformAndUserSettings(platform_params, user_params, url_params) {
    const platformSettings$ = this.callPlatformSettings(platform_params);
    const userSettings$ = this.callUserSettings(url_params, user_params);

    return forkJoin([platformSettings$, userSettings$])
  }

  onImgError(event, data) {
    event.target.src = data ? this.imagePath + data : "";
  }

}

export function getStripeKey() {
  return this.stripeKey;
}
export function getSecuredStripeKey() {
  const ls = new SecureLS({ isCompression: false });
  let stripeKey: string;
  try {
    stripeKey = ls.get('stripe_key');
  } catch (e) {
    stripeKey = localStorage.getItem('stripe_key');
  }
  return stripeKey;
}